<template>
  <div>
    <el-dialog
      title="绑定按钮"
      :visible.sync="assignDialogVisible"
      :append-to-body="true"
      width="30%"
      :close-on-click-modal="false"
      :before-close="closeDialog">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form" >
        <!-- <el-form-item label="菜单id" prop="menuId">
          <el-input v-model="form.menuId" autocomplete="off" placeholder="请输入" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="按钮列表" prop="accessIds">
          <el-select
          class="sel"
          ref="deviceScope"
          style="width:100%"
          v-model="form.accessIds"
          :multiple="true"
          @focus="focusStatus&&openDrawer()"
          filterable>
            <el-option
              v-for="item in charactorOptions"
              :key="item.buttonId"
              :label="item.buttonName"
              :value="item.buttonId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <Drawer
    v-if="drawerFlag"
    :accessData="accessData"
    :drawerFlag="drawerFlag"
    @closeDrawer = "closeDrawer"
    @getData="receive"/>
  </div>
</template>
<script>
import { listByMenuId } from '@/api/buttons' // btnsList,
import { bindAccess } from '@/api/modelManager'
import { eventBus } from '@/utils/eventBus'
import Drawer from './drawer'
export default {
  props: {
    assignDialogVisible: {
      type: Boolean,
      default: false
    },
    menuId: {
      type: Number
    }
  },
  components: {
    Drawer
  },
  data () {
    return {
      form: {},
      rules: {},
      charactorOptions: [],
      drawerFlag: false,
      focusStatus: true,
      accessData: []
    }
  },
  created () {
    this.form.menuId = this.menuId
    this.getBtnIds()
  },
  methods: {
    // 打开抽屉
    openDrawer () {
      this.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      this.accessData = Object.assign([], this.charactorOptions)
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取子组件数据
    receive (val) {
      console.log('子组件数据', val)
      this.charactorOptions = val
      this.form.accessIds = val.map(res => res.buttonId)
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取按钮列表
    /* getBtnList () {
      btnsList().then((res) => {
        console.log('list', res.data.data.list)
        this.charactorOptions = res.data.data.list
      })
    }, */
    // 按钮回显
    getBtnIds () {
      const params = {
        menuId: this.menuId
      }
      listByMenuId(params).then((res) => {
        if (res.data.code === 200 || res.data.code === 0) {
          if (res.data.data.length > 0) {
            this.form.accessIds = res.data.data.map(v => v.buttonId)
            this.charactorOptions = res.data.data
          } else {
            return false
          }
        }
      })
    },
    // 进行回显
    closeDialog () {
      this.$emit('closeAssignDialog')
    },
    submitForm () {
      console.log(this.form)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const accessIds = this.form.accessIds.join(',')
          console.log(accessIds)
          const params = {
            menuId: this.form.menuId,
            buttonIds: accessIds
          }
          bindAccess(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '权限分配成功'
              })
              this.$emit('closeAssignDialog', 1)
              // TODO: 将页面刷新变更为从vuex中调用接口
              // window.location.reload()
              // 刷新菜单列表更新按钮的状态
              eventBus.$emit('updataMentList')// 更新左侧菜单
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .sel{
    /deep/ .el-icon-close{
      display: none;
    }
  }

  /deep/ .el-select-dropdown{
    z-index: 0;
    display: none;
  }
</style>
